var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{class:_vm.navBarClass,attrs:{"id":"navBar","type":"light","toggleable":"sm","variant":"light"}},[_c('b-navbar-brand',{attrs:{"disabled":true}},[_c('b-img',{staticClass:"img",attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/paymenthub-6f141.appspot.com/o/unnamed%20v2.png?alt=media&token=e4c3cd9d-fc37-4f09-bb0b-92910571010d","alt":"Logo Payment Innovation Hub"}})],1),(
      _vm.$route.path !== '/event/prensa' &&
      _vm.$route.path !== '/register' &&
      _vm.$route.path !== '/'
    )?_c('b-container',[_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }